import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import Loader from '../../../utils/Loader'
import { fill_action } from '../../../actions/fillList_action';
import { get_userDetails_action, addUpdate_user_action } from '../../../actions/security_action/user_action';
import { roleActionId, cityActionId, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants';
import Select from 'react-select';
import { ToastContainer, toast, } from 'react-toastify';
// import moment from 'moment'
import moment from 'moment-timezone'
import Header from '../../../common_components/Header';
import { emailValidator, mobileNoValidator, passwordValidator, confirmPasswordValidator } from '../../../utils/Validator'

const mapStateToProps = state => ({
    ...state
})

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};
const deletedStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        display: "none" // Remove icon color for selected value
    }),
};
const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    />
));

class UserAU extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            userAdd: false,
            userUpdate: false,
            userID: '',
            checkboxFlag: false,
            roleId: '',
            roleList: [],
            userName: '',
            designation: '',
            phone: '',
            email: '',
            userDate: '',
            location: '',
            userDateOfBirth: '',
            createdBy: '',
            createdDate: '',
            deletedBy: '',
            deletedDate: '',
            modifiedBy: '',
            modifiedDate: '',
            cityId: [],
            cityList: [],
            CityName: '',
            tempCityList: [],
            selectCityList: [],
            city_IdList: [],
            isAccordionExpanded: false,
            getCityId: [],
            mainCityList: [],
            isCollapse: false,
            statusId: 1,
            Password: '',
            confirmPassword: '',
            roleIdErr: '',
            userNameErr: '',
            emailErr: '',
            PasswordErr: '',
            confirmPasswordErr: '',
        }
    }

    componentDidMount() {
        this.getFillList(roleActionId, '')
        this.getFillList(cityActionId, '')

        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);

        this.setState({
            userAdd: this.props.location.state != null && this.props.location.state.userAdd != null ? this.props.location.state.userAdd : false,

            userUpdate: this.props.location.state != null && this.props.location.state.userUpdate != null ? this.props.location.state.userUpdate : false,

            userID: this.props.location.state != null && this.props.location.state.userID != null ? this.props.location.state.userID : '',
        })


        this.props.location.state != null && this.props.location.state.userUpdate && this.getUserDetails()
    }

    inputValidate() {
        const { userName, email, Password, confirmPassword, roleId } = this.state

        if (roleId == "" || roleId == null || roleId == 'Select') {
            this.setState({ roleIdErr: 'Please select role' })
        }
        if (userName == "" || userName == null) {
            this.setState({ userNameErr: 'Please enter name' })
        }
        if (email == "" || email == null) {
            this.setState({ emailErr: 'Please enter email' })
        }
        if (Password == "" || Password == null) {
            this.setState({ PasswordErr: 'Please enter password' })
        }
        if (confirmPassword == "" || confirmPassword == null) {
            this.setState({ confirmPasswordErr: 'Please enter confirm password' })
        }
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID)
            .then((data) => {
                if (data.error != 1) {
                    if (value == roleActionId) {
                        this.setState({ roleList: data.data, isLoading: false })
                        console.log("roleList", data.data)
                    }
                    if (value == cityActionId) {
                        var tempCityArr = []
                        for (var i = 0; i < data.data.length; i++) {
                            var cityObj = {}
                            cityObj.label = data.data[i].CityName
                            cityObj.value = data.data[i].Code
                            tempCityArr.push(cityObj)
                        }
                        this.setState({ cityList: tempCityArr, isLoading: false, });
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    getUserDetails() {
        const { mainCityList, getCityId } = this.state
        this.setState({ isLoading: true })
        var id = this.props.location.state != null && this.props.location.state.userID != null ? this.props.location.state.userID : ''
        console.log("userId", id)
        this.props
            .get_userDetails_action(id)
            .then((data) => {
                if (data.error != 1) {


                    this.setState({
                        roleId: data.data[0]['RoleID'],
                        userName: data.data[0]['Name'],
                        designation: data.data[0]['Designation'],
                        phone: data.data[0]['Phone'],
                        email: data.data[0]['Email'],
                        // userDate: data.data[0]['DateOfBirth'],
                        Password: data.data[0]['Password'],
                        confirmPassword: data.data[0]['Password'],
                        // userDateOfBirth: data.data[0]['DateOfBirth'] != null ? moment(data.data[0]['DateOfBirth'], 'DD-MM-YYYY').toDate() : null,
                        createdBy: data.data[0]['CreatedBy'],
                        createdDate: data.data[0]['CreatedDate'] != null ? moment(data.data[0]['CreatedDate']).format('DD-MM-YYYY') : null,
                        deletedBy: data.data[0]['DeletedBy'],
                        deletedDate: data.data[0]['DeletedDate'] != null ? moment(data.data[0]['DeletedDate']).format('DD-MM-YYYY') : null,
                        modifiedBy: data.data[0]['ModifiedBy'],
                        modifiedDate: data.data[0]['ModifiedDate'] != null ? moment(data.data[0]['ModifiedDate']).format('DD-MM-YYYY') : null,
                        getCityId: data.data[0]['CityID'] != null ? data.data[0]['CityID'] : null,
                        // cityId: data.data[0]['CityID'] != null ? data.data[0]['CityID'] : null,
                        statusId: data.data[0]['StatusID'] != null ? data.data[0]['StatusID'] : null,

                    })
                    this.setState({ isLoading: false })

                    setTimeout(() => {
                        if (this.state.getCityId != null && this.state.getCityId != '') {
                            const getCityIdArray = []
                            const newCityArray = []
                            getCityIdArray.push(this.state.getCityId.split(','))
                            getCityIdArray[0].map(data => {
                                for (let i = 0; i < this.state.cityList.length; i++) {
                                    if (data == this.state.cityList[i]['value']) {
                                        newCityArray.push({
                                            'label': this.state.cityList[i]['label'],
                                            'value': this.state.cityList[i]['value']
                                        })
                                    }
                                }

                            })
                            this.setState({ cityId: newCityArray })
                        }
                    }, 300);

                    // setTimeout(() => {
                    //     if (this.state.getTypeOfEventID != null) {
                    //         const getEventIdArray = [];
                    //         const newEventArray = [];
                    //         getEventIdArray.push(this.state.getTypeOfEventID.split(","));
                    //         console.log(getEventIdArray, '2')
                    //         getEventIdArray[0].map((data,) => {
                    //             for (let i = 0; i < this.state.TypeOfEventList.length; i++) {
                    //                 if (data == this.state.TypeOfEventList[i]['value']) {

                    //                     newEventArray.push({
                    //                         label: this.state.TypeOfEventList[i]["label"],
                    //                         value: this.state.TypeOfEventList[i]["value"],
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //         this.setState({ EventName: newEventArray });
                    //     }
                    // }, 300);




                }
                else {
                    if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toast.error(data.msg, {
                            position:"top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                    }else{
                    this.setState({ isLoading: false })
                    toast.error(data.data, {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }}
            })
            .catch((e) => {
                console.log(e);
            });
    }

    addUpdateUser() {
        const { userName, email, phone, userDateOfBirth, designation, location, roleId, cityId, Password, confirmPassword, statusId } = this.state
        var UserId = this.props.location.state != null && this.props.location.state.userID != null ? this.props.location.state.userID : ''
        this.setState({ isLoading: true })
        this.inputValidate()
        // console.log("newArr", cityId)
        const newArr = []
        cityId.map(item => {
            newArr.push({
                'CityID': item.value
                // 'CityID': cityId != '' && cityId != 'Select' ? cityId : null
            })
        })

        if (userName != '' && userName != null && email != '' && email != null && roleId != '' && roleId != null && roleId != 'Select' && Password != '' && Password != null) {

            var emailErrMsg = emailValidator(email)
            var mobileErrMsg = mobileNoValidator(phone)
            var passwordErrMsg = passwordValidator(Password)
            var confirmPasswordErrMsg = confirmPasswordValidator(confirmPassword, Password)

            if (emailErrMsg != '' || mobileErrMsg != '' || passwordErrMsg != '' || confirmPasswordErrMsg != '') {

                toast.error(
                    emailErrMsg != '' ? emailErrMsg :
                        mobileErrMsg != '' ? mobileErrMsg :
                            passwordErrMsg != '' ? passwordErrMsg :
                                confirmPasswordErrMsg != '' ? confirmPasswordErrMsg :
                                    '',
                    {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })
                this.setState({ isLoading: false })
            } else {
                this.props
                    .addUpdate_user_action(UserId, userName, email, phone, designation, Password, roleId, statusId, newArr)
                    .then((data) => {
                        if (data.error != 1) {
                            this.props.navigate('/user')
                            this.setState({ isLoading: false })
                        }
                        else {
                            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                                //after session expire.....................
                                sessionStorage.clear()
                                this.props.navigate('/normalView')
                                setTimeout(() => {
                                  toast.error(data.msg, {
                                    position:"top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                  });
                                }, 500);
                            }else{
                            this.setState({ isLoading: false })
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: 'colored',
                                autoClose: 3000,
                                hideProgressBar: true,
                            })
                        }}
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }

        } else {
            toast.error('please enter mendatory feilds', {
                position: "top-center",
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
            this.setState({ isLoading: false })
        }
    }

    handleCancel() {
        this.props.navigate('/user')
    }


    checkbox() {
        const { statusId } = this.state
        this.setState({
            statusId: !statusId,
        })
    }

    render() {
        const { isLoading, checkboxFlag, userName, designation, roleId, roleList, phone, email, userDateOfBirth, location, checked, createdBy, createdDate, deletedBy, deletedDate, modifiedBy, modifiedDate, CityName, isDisplayCityList, userAdd, cityId, cityList, isAccordionExpanded, isCollapse, userUpdate, statusId, Password, confirmPassword,
            roleIdErr,
            userNameErr,
            emailErr,
            PasswordErr,
            confirmPasswordErr, } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    <>

                        <main id="main">
                            <Header data={[22]} />
                            <section style={{ marginTop: "115px" }}>
                                <div class="container-fluid">
                                    <div class="page-header">
                                        <h4 class="page-title">{userAdd ? 'Add' : 'Update'} User</h4>
                                        <div class="Service_display pt-2">
                                            <h6 class="Services_Active_or_Not">{statusId ? 'Active' : 'InActive'}</h6>
                                            <div class="checkbox checbox-switch">
                                                <label class="switch" >
                                                    <input type="checkbox"
                                                        selected={statusId}
                                                        checked={statusId}
                                                        value={statusId}
                                                        onClick={(e) => userUpdate ? this.checkbox(e) : ''}
                                                    />
                                                    <span class="slider round" ></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card Service_fields">
                                        <div class="card-body">


                                            <div class="row">
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip" >Name <span class="mendatory_class">*</span> </label>
                                                    <input type="text" value={userName}
                                                        maxLength={100}
                                                        // disabled={statusId == '0'}
                                                        onChange={(e) => this.setState({ userName: e.target.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), userNameErr:'' })}
                                                        class="form-control" id="fname" name="name" />
                                                    <span className='text-danger text-start text-left d-block mt-1'>{userNameErr}</span>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip"> Email <span class="mendatory_class">*</span></label>
                                                    <input type="email" value={email}
                                                        // disabled={userUpdate || statusId == '0'}
                                                        onChange={(e) => this.setState({ email: e.target.value, emailErr:'' })}
                                                        maxLength={100}
                                                        class="form-control" id="email" name="email" />
                                                    <span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip">Password
                                                        <span class="mendatory_class">*</span>
                                                    </label>
                                                    <input type="text" value={Password} class="form-control" id="Password" name="Password"
                                                        // disabled={statusId == '0'}
                                                        maxLength={100}
                                                        onChange={(e) => this.setState({ Password: e.target.value,PasswordErr:'' })}
                                                    />
                                                    <span className='text-danger text-start text-left d-block mt-1'>{PasswordErr}</span>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip">Confirm Password <span class="mendatory_class">*</span></label>
                                                    <input type="text" value={confirmPassword} class="form-control" id="Password" name="Password"
                                                        // disabled={statusId == '0'}
                                                        maxLength={100}
                                                        onChange={(e) => this.setState({ confirmPassword: e.target.value, confirmPasswordErr:'' })}
                                                    />
                                                    <span className='text-danger text-start text-left d-block mt-1'>{confirmPasswordErr}</span>
                                                </div>
                                                {/* <div class="form-group col-md-3">
                                                    <label for="inputZip"> Date Of Birth <span class="mendatory_class">*</span> </label>
                                                    <DatePicker
                                                        class="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={userDateOfBirth}
                                                        maxDate={currentDate}
                                                        value={userDateOfBirth}
                                                        // disabled={statusId == '0'}
                                                        onChange={(date) => { this.setState({ userDateOfBirth: date }) }}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        customInput={<ExampleCustomInput />}
                                                        dayClassName={() => "example-datepicker-day-class"}
                                                        popperClassName="example-datepicker-class"
                                                    />
                                                </div> */}
                                            </div>
                                            <div class="row">
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip"> Mobile No
                                                        {/* <span class="mendatory_class">*</span>  */}
                                                    </label>
                                                    <input type="tel" class="form-control" id="phone" name="phone" maxlength="10" onkeypress="return event.charCode >= 48 &amp;&amp; event.charCode <= 57" value={phone}
                                                        // disabled={statusId == '0'}
                                                        onChange={(e) => this.setState({ phone: e.target.value.replace(/\D/, '') })}
                                                        maxLength={10}
                                                    />
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputZip">Designation
                                                        {/* <span class="mendatory_class">*</span> */}
                                                    </label>
                                                    <input type="text" class="form-control" id="Designation" name="Designation" value={designation}
                                                        // disabled={statusId == '0'}
                                                        maxLength={100}
                                                        onChange={(e) => this.setState({
                                                            designation: e.target.value.split(' ')
                                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                .join(' ')
                                                        })}
                                                    />
                                                </div>

                                                <div class="form-group col-md-3">
                                                    <label for="inputZip">Role <span class="mendatory_class">*</span> </label>
                                                    <select class="form-control"
                                                        value={roleId}
                                                        disabled={userUpdate}
                                                        onChange={(e) => this.setState({ roleId: e.target.value, roleIdErr:'' })}>

                                                        <option>Select</option>
                                                        {roleList.length > 0 && roleList.map(item => (
                                                            <option
                                                                key={item.RoleID}
                                                                value={item.RoleID}>
                                                                {item.RoleName}
                                                            </option>
                                                        ))}

                                                    </select>
                                                    <span className='text-danger text-start text-left d-block mt-1'>{roleIdErr}</span>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div className="col-md-6 form-group">
                                                    <label>City
                                                        {/* <span class="mendatory_class">*</span> */}
                                                    </label>
                                                    <Select
                                                        isMulti
                                                        // isDisabled={statusId == '0'}
                                                        // isClearable={statusId != '0'}
                                                        // styles={statusId == '0' ? deletedStyles : customStyles}
                                                        styles={customStyles}
                                                        value={cityId}
                                                        onChange={e => this.setState({ cityId: e })}
                                                        options={cityList} />
                                                </div>

                                            </div>

                                            {
                                                userUpdate ?
                                                    <div class="system_info">
                                                        <div class="row row_margin collpase_arrow_cursor">
                                                            <div class="col-md-6 col-sm-6 col-7">
                                                                <span data-toggle="collapse" data-target="#Sys_info" aria-expanded="false" class="">
                                                                    {
                                                                        !isCollapse ?
                                                                            <>
                                                                                <div onClick={() => this.setState({ isCollapse: !isCollapse })}>
                                                                                    <i class="fa fa-chevron-right " style={{ fontSize: "12px", color: "#898989" }}></i>
                                                                                    <span class="heading_text" style={{ paddingLeft: "5px" }}>System Info</span>
                                                                                </div>
                                                                            </> :
                                                                            <>
                                                                                <div onClick={() => this.setState({ isCollapse: !isCollapse })}>
                                                                                    <i class="fa fa-chevron-down" style={{ fontSize: "12px", color: "#898989" }}></i>
                                                                                    <span class="heading_text" style={{ paddingLeft: "5px" }}>System Info</span>
                                                                                </div>
                                                                            </>
                                                                    }

                                                                </span>
                                                            </div>
                                                            <div class="col-md-6 col-sm-6 col-5 text-right">
                                                            </div>
                                                        </div>
                                                        <hr style={{ marginTop: "0px", marginBottom: '15px', border: '1px solid #c0c0c0' }} />
                                                        {/* <div class="CRM_details_div collapse" id="Sys_info" > */}
                                                        {
                                                            isCollapse ?
                                                                <div class="" id="Sys_info" >
                                                                    <div class="form-group">
                                                                        <div class="row">
                                                                            <div class="col-md-4">
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Created By</label>
                                                                                    <p class="Sys_info_style">{createdBy}</p>
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Created Date</label>
                                                                                    <p class="Sys_info_style">{createdDate}</p>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-4">
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Modified By</label>
                                                                                    <p class="Sys_info_style">{modifiedBy}</p>
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Modified Date</label>
                                                                                    <p class="Sys_info_style">{modifiedDate}</p>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-4">
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Deleted By</label>
                                                                                    <p class="Sys_info_style">{deletedBy}</p>
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label class="sys_info_label" for="email">Deleted Date</label>
                                                                                    <p class="Sys_info_style">{deletedDate}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> :
                                                                <></>
                                                        }
                                                    </div>
                                                    : <></>
                                            }


                                            <div class="row">
                                                <div class="col-md-12">
                                                    {
                                                        userAdd ?
                                                            <a onClick={(e) => this.addUpdateUser(e)} class="btn save_btn mr-2" >Save</a>
                                                            :
                                                            <a onClick={(e) => this.addUpdateUser(e)} class="btn save_btn mr-2">Update</a>
                                                    }
                                                    <a onClick={(e) => this.handleCancel(e)} class="btn back_btn">Back</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </section>



                        </main>

                    </>
                )
                }
                <ToastContainer />
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_userDetails_action, addUpdate_user_action })(UserAU));